import '../utils/hotspots.js';
const blockReproductive = () => {
  $('.ovary-img')
    .on('load', function () {
      // Your function here
      console.log('Image is loaded!');
      $('#hotspotImg').hotSpot({
        // default selectors
        mainselector: '#hotspotImg',
        selector: '.hot-spot',
        imageselector: '.img-responsive',
        tooltipselector: '.tooltip',
    
        // or 'click'
        bindselector: 'click',
      });
      $('.hotspot-container.active .hot-spot:first').trigger('click');
    })
    .each(function () {
      // For cached images, manually trigger the load event if it’s already cached
      if (this.complete) $(this).trigger('load');
    });

  $('.toggle-pill').on('click', function () {
    $('.toggle-pill').removeClass('active');
    $(this).addClass('active');
    $('.hotspot-container').removeClass('active');
    $(`.hotspot-container[data-hotspots="${$(this).attr('id')}"]`).addClass(
      'active'
    );
    $('.hotspot-container.active .hot-spot:first').trigger('click');
  });
};
export default blockReproductive;
